import { CompanyDto } from "../companies/companyDto";
import { HealthCertificateDto } from "../healthCertificates/healthCertificate.dto";
import { DefaultIndicatorsDto, emptyIndicators } from "../medicalIndicators/defaultIndicatorsDto";
import { UserShortDto, emptyUser } from "../users/userShortDto";

export interface DriverDto {
  id: number | null;
  user: UserShortDto;
  employeeNumber: string;
  snils: string;
  licenceSerial: string;
  licenceNumber: string;
  licenceIssued: Date | null;
  licenceExpired: Date | null;
  passportSerial: string;
  passportNumber: string;
  defaultIndicators: DefaultIndicatorsDto;
  photoFile: File | null;
  company: CompanyDto | null;
  healthCertificates: HealthCertificateDto[];
  isHidCardLinked: boolean;
}

export const emptyDriver: DriverDto = {
  id: null,
  user: emptyUser,
  employeeNumber: '',
  snils: '',
  licenceSerial: '',
  licenceNumber: '',
  licenceIssued: null,
  licenceExpired: null,
  passportSerial: '',
  passportNumber: '',
  defaultIndicators: emptyIndicators,
  photoFile: null,
  company: null,
  healthCertificates: [],
  isHidCardLinked: false,
};
